import { useParams } from "react-router-dom";
import { pluck } from "ramda";
import querystring from "query-string";
import { useUnitListsContext } from "@unitLists/context";
import { nthPreviousPeriod, getPeriod } from "utils/periods";
import { colorOptions } from "utils/colors";
import { useMeasuresContext } from "@webapi/contexts/measures";
export default function useDefaultParams() {
  var _nthPreviousPeriod;
  var _useUnitListsContext = useUnitListsContext(),
    activeUnitList = _useUnitListsContext.activeUnitList,
    defaultRegions = _useUnitListsContext.defaultRegions;
  var _useParams = useParams(),
    id = _useParams.id;
  var _useMeasuresContext = useMeasuresContext(),
    lookupParentMeasure = _useMeasuresContext.lookupParentMeasure;
  var query = querystring.parse(location.search);
  var urlUnits = query.units && [].concat(query.units);
  var parentMeasure = lookupParentMeasure(id);
  var sort = query.sort || (parentMeasure === null || parentMeasure === void 0 ? void 0 : parentMeasure.soughtValue) === "Lågt" ? "asc" : "desc";
  var defaultUnits = activeUnitList && pluck("id", activeUnitList === null || activeUnitList === void 0 ? void 0 : activeUnitList.units) || [];
  var units = urlUnits || defaultUnits;

  // Determine whether the page was accessed through the indicator search
  if (query.search) {
    units = defaultRegions;
  }
  var defaultPeriodType = "Month";
  var currentPeriod = getPeriod(defaultPeriodType, new Date());
  return {
    parentMeasure: id,
    measureIds: [id],
    units: units,
    periodType: defaultPeriodType,
    dateFrom: (_nthPreviousPeriod = nthPreviousPeriod(defaultPeriodType, currentPeriod, 5)) === null || _nthPreviousPeriod === void 0 ? void 0 : _nthPreviousPeriod.start,
    dateTo: currentPeriod.end,
    relatedMeasuresByEntry: null,
    relatedMeasuresById: null,
    graphSelected: "timeline",
    sort: sort,
    relativeTo: "se",
    showPrevious: false,
    showTarget: true,
    showCi: false,
    showReich: false,
    zoom: false,
    colorSettings: colorOptions.MANY_COLORS.id,
    showImgView: false
  };
}